export default "__VITE_ASSET__ByGZdzzf__"